import { render, staticRenderFns } from "./KinasePhosphatase.vue?vue&type=template&id=59d38f83&scoped=true"
import script from "./KinasePhosphatase.vue?vue&type=script&lang=js"
export * from "./KinasePhosphatase.vue?vue&type=script&lang=js"
import style0 from "./KinasePhosphatase.vue?vue&type=style&index=0&id=59d38f83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d38f83",
  null
  
)

export default component.exports